module.exports = __webpack_public_path__ + "static/media/xuetugong1.79d6f47c.png";